export default {
    title: " ",
    type: "object",
    required: ["enrollmentAssistantId", "enrollmentAssistantName"],
    properties: {
        enrollmentAssistantId: {
            type: "string",
            title: "Enrollment Assistant ID"
        },
        enrollmentAssistantName: {
            type: "string",
            title: "Enrollment Assistant Name"
        }
    }
};